globalThis.closeto = function closeto(left, right) {
  return Math.abs(left - right) < 0.02;
};
